export default __webpack_public_path__ + "static/media/D-DIN.0b3582f5.eot";